import app from '../../config/configApp';
import VueCookies from 'vue3-cookies';

app.use(VueCookies, {
  expireTimes: '7d',
});
